import { render, staticRenderFns } from "./querySelect.vue?vue&type=template&id=36dee0ec&scoped=true"
import script from "./querySelect.vue?vue&type=script&lang=js"
export * from "./querySelect.vue?vue&type=script&lang=js"
import style0 from "./querySelect.vue?vue&type=style&index=0&id=36dee0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dee0ec",
  null
  
)

export default component.exports